import HTTP from "@/_helpers/http";
import { NEWS__API } from "@/_helpers/urls";
import { NEWS__MUTATIONS } from "../mutation-types";
import { NEWS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  singlenews: null,
  news: [],
  newsCategories: [],
  isLoading: false,
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [NEWS__MUTATIONS.GETNEWS](state, data) {
    state.news = data?.data;
  },
  [NEWS__MUTATIONS.NEWSCATEGORIES](state, data) {
    state.newsCategories = data;
  },
  [NEWS__MUTATIONS.SINGLENEWS](state, data) {
    state.singlenews = data?.data;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
};

// Actions
const actions = {
  async [NEWS__ACTIONS.GETNEWS]({ commit, state }, parameter) {
    try {
      commit("SET_LOADING", true);

      const response = await HTTP().get(NEWS__API.GETNEWS);

      commit(NEWS__MUTATIONS.GETNEWS, response.data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },

  async [NEWS__ACTIONS.NEWSCATEGORIES]({ commit, state }) {
    try {
      const response = await HTTP().get(NEWS__API.NEWSCATEGORIES);
      commit(NEWS__MUTATIONS.NEWSCATEGORIES, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [NEWS__ACTIONS.SINGLENEWS]({ commit, state }, parameter) {
    try {
      const response = await HTTP().get(
        NEWS__API.SINGLENEWS + "/" + parameter?.id
      );
      commit(NEWS__MUTATIONS.SINGLENEWS, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [NEWS__ACTIONS.DELETENEWS]({ commit, state, dispatch }, parameter) {
    try {
      commit("SET_LOADING", true);

      const response = await HTTP().delete(
        NEWS__API.DELETENEWS + "/" + parameter?.id
      );
      if (response) {
        toast.success(response?.data?.message);
      }

      await dispatch(NEWS__ACTIONS.GETNEWS);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },

  async [NEWS__ACTIONS.UPDATENEWS]({ commit, state, dispatch }, parameter) {
    try {
      commit("SET_LOADING", true);

      const idParam = parameter?.id != null ? `id=${parameter.id}` : "";

      const titleParam =
        parameter?.title != null ? `title=${parameter.title}` : "";

      const news_category_idParam =
        parameter?.news_category_id != null
          ? `news_category_id=${parameter.news_category_id}`
          : "";

      const descriptionParam =
        parameter?.description != null
          ? `description=${parameter.description}`
          : "";

      const parameterString = [
        idParam,
        descriptionParam,
        news_category_idParam,
        titleParam,
      ]
        .filter((param) => param !== "")
        .join("&");

      const response = await HTTP().patch(
        NEWS__API.UPDATENEWS +
        (parameterString !== "" ? `?${parameterString}` : "")
      );

      if (response) {
        toast.success(response?.data?.message);
      }

      await dispatch(NEWS__ACTIONS.GETNEWS);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },

  async [NEWS__ACTIONS.ADDNEWS]({ commit, state, dispatch }, parameter) {
    try {
      commit("SET_LOADING", true);

      const titleParam =
        parameter?.title != null ? `title=${parameter.title}` : "";

      const news_category_idParam =
        parameter?.news_category_id != null
          ? `news_category_id=${parameter.news_category_id}`
          : "";

      const descriptionParam =
        parameter?.description != null
          ? `description=${parameter.description}`
          : "";

      const parameterString = [
        descriptionParam,
        news_category_idParam,
        titleParam,
      ]
        .filter((param) => param !== "")
        .join("&");

      const response = await HTTP().post(
        NEWS__API.ADDNEWS +
        (parameterString !== "" ? `?${parameterString}` : "")
      );

      if (response) {
        toast.success(response?.data?.message);
      }

      await dispatch(NEWS__ACTIONS.GETNEWS);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
